import type { RouteResponseType } from './RoutesApi';
import { Location } from '../../Location/Location';
import { CalculationResult } from '../../CalculationResult/CalculationResult';
import { Calculation } from '../../Calculation/Calculation';

export class RouteOne {
    private _innerId: string;
    private _route: RouteResponseType | null = null;
    private _locationFrom: Location | null = null;
    private _locationTo: Location | null = null;
    private _calculation: Calculation | null = null;
    private _calculationResult: CalculationResult | null = null;

    public constructor() {
        this._innerId = Math.random().toString(36).substring(7);
    }

    getId() {
        if (!this._route?.connection.id) {
            throw new Error('RouteOne.getId: connection.id is not set');
        }
        return this._route?.connection.id;
    }

    public set(route: RouteResponseType): void {
        this._route = route;
        this._locationFrom = new Location().set(route.location_from);
        this._locationTo = new Location().set(route.location_to);
        this._calculation = new Calculation().set(route.calculation);
        this._calculationResult = new CalculationResult().set(route.calculation_result);
    }

    public get(): RouteResponseType | null {
        return this._route;
    }

    public getCalculationResult(): CalculationResult {
        if (!this._calculationResult) {
            throw new Error('RouteOne.getCalculationResult: calculationResult is not set');
        }
        return this._calculationResult;
    }

    public getCalculation(): Calculation {
        if (!this._calculation) {
            throw new Error('RouteOne.getCalculation: calculation is not set');
        }
        return this._calculation;
    }

    public getFrom(): Location {
        if (!this._route?.location_from) {
            throw new Error('RouteOne.getFrom: location_from is not set');
        }
        return new Location().set(this._route?.location_from);
    }

    public getTo(): Location {
        if (!this._route?.location_to) {
            throw new Error('RouteOne.getTo: location_to is not set');
        }
        return new Location().set(this._route?.location_to);
    }

    public getNote(): string {
        return this._route?.connection.note || '';
    }

    public setNote(note: string): void {
        if (!this._route) {
            throw new Error('RouteOne.setNote: route is not set');
        }
        this._route.connection.note = note;
    }

    public isAdHoc(): boolean {
        return this._route?.connection.is_ad_hoc || false;
    }

    public isModified(): boolean {
        return this._route?.modified || false;
    }

    public getRouteTypeName(): string {
        return this._route?.route_type?.name || '';
    }

    public isOutdated(): boolean {
        return this._route?.outdated || false
    }
}
